<div class="dialog-container">
  <h2 mat-dialog-title class="dialog-header">{{ getDialogTitle() }}</h2>

  <!-- Selection Mode -->
  <div mat-dialog-content *ngIf="currentMode === 'selection'">
    <div class="selection-container">
      <p class="selection-description">Choose the type of connection you want to add:</p>
      <button mat-raised-button color="primary" class="selection-button" (click)="onSelectCompany()">
        <div class="button-content">
          <span class="button-title">Company</span>
          <span class="button-description">Connect to an existing company</span>
        </div>
      </button>
      <button mat-raised-button color="primary" class="selection-button" (click)="onSelectOpbCompany()">
        <div class="button-content">
          <span class="button-title">OPB Company</span>
          <span class="button-description">Connect to an existing OPB company</span>
        </div>
      </button>
      <button mat-raised-button color="primary" class="selection-button" (click)="onSelectDirector()">
        <div class="button-content">
          <span class="button-title">Director</span>
          <span class="button-description">Connect to an existing director</span>
        </div>
      </button>
    </div>
  </div>

  <!-- Search & Connect Mode -->
  <div mat-dialog-content *ngIf="currentMode === 'search-connect'">
    <ngx-spinner></ngx-spinner>
    @if (selectedEntityType === 'director') {
      <app-add-connection-director-search
        (directorSelected)="onDirectorSelected($event)">
      </app-add-connection-director-search>
    } @else if (selectedEntityType === 'company') {
      <app-add-connection-company-search
        (companySelected)="onCompanySelected($event)">
      </app-add-connection-company-search>
    } @else if (selectedEntityType === 'opb-company') {
      <app-add-connection-opb-company-search
        (opbCompanySelected)="onOpbCompanySelected($event)">
      </app-add-connection-opb-company-search>
    }
  </div>

  <!-- Dialog Actions -->
  <div mat-dialog-actions class="dialog-actions">
    <button mat-flat-button type="button" (click)="onBack()" *ngIf="currentMode !== 'selection'">
      <mat-icon>arrow_back</mat-icon>
      Back
    </button>
    <button mat-flat-button type="button" class="nrg-error-flat-button back-button" (click)="onCancel()">
      <mat-icon>clear</mat-icon>
      Cancel
    </button>
    <button mat-flat-button color="primary" (click)="onConfirm()"
            [disabled]="!isFormValid"
            *ngIf="currentMode === 'search-connect'">
      <mat-icon>add</mat-icon>
      Add Connection
    </button>
  </div>
</div>
